import PropTypes from "prop-types";
import {useEffect, useRef} from "react";
import IconBoxData from '../../data/product/products.json';
import IconBox from '../../components/IconBox/IconBoxWithImage.jsx';
import SectionTitle from '../../components/SectionTitles/SectionTitle';
import Parallax from 'parallax-js';
import {getTranslated} from "../../utils/languageUtil";

const ProductIconBox = ({ classOption }) => {
    const sceneEl = useRef(null);
    const content = getTranslated('Product')['productBox'];
    useEffect(() => {
        const parallaxInstance = new Parallax(sceneEl.current, {
        relativeInput: true,
        })
        
        parallaxInstance.enable();

        return () => parallaxInstance.disable();

    }, [])
    return (
        <div className={`section section-padding-t90 section-padding-bottom ${classOption}`}>
            <div className="container">

                <SectionTitle
                    headingOption="fz-32"
                    title={content['title']}
                />

                <div className="row row-cols-lg-4 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6 icon-box-shape-animation">

                    {IconBoxData && IconBoxData.map((single, key) => {
                        return(
                            <div key={key} className="col mb-6" data-aos="fade-up" data-aos-delay="300">
                                <IconBox classOption="box-border" data={single} key={key} />
                            </div>
                        ); 
                    })}

                    <div className="shape shape-1" id="scene" ref={sceneEl}>
                        <span data-depth="1"><img src={process.env.PUBLIC_URL + "/images/shape-animation/video-shape-1.png"} alt="" /></span>
                    </div>

                </div>

            </div>
        </div>
    )
}

ProductIconBox.propTypes = {
    classOption: PropTypes.string
};
ProductIconBox.defaultProps = {
    classOption: "section section-padding-t90 section-padding-bottom"
};

export default ProductIconBox
